export const organization = "Organization";

// Filters out common "none" organizations such as empty string, "None", "N/A", "."
export const filterNoneOrgs = (org: string) => {
  const o = org.trim();
  return o.length !== 0 && !/^(none|n\/a|\.|mine|self|me|personal)$/i.test(o);
};
